function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { blocks, layoutBlocks } from "./defaultBlocks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var templateCardStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: 8,
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  padding: 6,
  color: "#0f172a",
  cursor: "pointer",
  textAlign: "left",
  width: "100%",
  transition: "all 0.2s ease-in-out",
  boxShadow: "none"
};
export var sectionTemplates = {
  hero: {
    label: "Hero section",
    icon: "hero",
    blocks: [{
      type: "heading",
      content: {
        text: "Transform Your Business With WillowSpace"
      },
      style: {
        fontSize: "42px",
        textAlign: "center",
        color: "#1e293b",
        fontWeight: 700,
        padding: "20px"
      }
    }, {
      type: "text",
      content: {
        text: "We help modern agencies, freelancers, and small businesses streamline their documents, contracts, proposals, and client management in one unified space."
      },
      style: {
        fontSize: "16px",
        textAlign: "center",
        color: "#64748b",
        padding: "10px 40px"
      }
    }, {
      type: "button",
      content: {
        text: "Get Started Now",
        url: "#",
        target: "_blank"
      },
      style: {
        padding: "12px 28px",
        borderRadius: "24px",
        color: "#ffffff",
        background: "#101828",
        fontSize: "16px",
        textAlign: "center",
        cursor: "pointer"
      }
    }]
  },
  quote: {
    label: "Quote block",
    icon: "quote",
    blocks: [blocks.find(function (b) {
      return b.type === "quote";
    })]
  },
  gallery: {
    label: "Image gallery",
    icon: "gallery",
    blocks: [blocks.find(function (b) {
      return b.type === "gallery";
    })]
  },
  cta: {
    label: "CTA banner",
    icon: "cta",
    blocks: [blocks.find(function (b) {
      return b.type === "cta";
    })]
  },
  threeColumn: {
    label: "3-column layout",
    icon: "three-column",
    blocks: [blocks.find(function (b) {
      return b.type === "three-column";
    })]
  },
  oneColumn: {
    label: "1-column layout",
    icon: "one-column",
    blocks: [blocks.find(function (b) {
      return b.type === "one-column";
    })]
  },
  logos: {
    label: "Logo strip",
    icon: "logos",
    blocks: [blocks.find(function (b) {
      return b.type === "logos";
    })]
  },
  logoText: {
    label: "Logo + Text",
    icon: "logos",
    blocks: [{
      type: "two-column",
      content: {
        columns: [[{
          type: "image",
          content: {
            src: "https://placehold.co/160x160/f1f5f9/0f172a.png?text=Logo",
            url: "",
            alt: "Company logo"
          },
          style: {
            padding: "0",
            margin: "0",
            borderRadius: "12px",
            width: "100%",
            textAlign: "left"
          }
        }], [{
          type: "heading",
          content: {
            text: "Your Brand Name",
            tag: "h2"
          },
          style: {
            fontSize: "22px",
            fontWeight: 700,
            color: "#0f172a",
            padding: "0",
            margin: "0 0 6px 0",
            textAlign: "left"
          }
        }, {
          type: "text",
          content: {
            text: "Short tagline or description about your brand."
          },
          style: {
            fontSize: "14px",
            color: "#64748b",
            lineHeight: 1.5,
            padding: "0",
            margin: "0",
            textAlign: "left"
          }
        }]]
      },
      style: {
        gap: "20px",
        alignItems: "center",
        borderRadius: "12px",
        background: "#ffffff",
        columnWidths: ["120px", "auto"],
        columnPaddings: ["0px", "0px"]
      }
    }]
  },
  accordion: {
    label: "FAQ accordion",
    icon: "accordion",
    blocks: [blocks.find(function (b) {
      return b.type === "accordion";
    })]
  },
  pricing: {
    label: "Pricing table",
    icon: "pricing",
    blocks: [blocks.find(function (b) {
      return b.type === "pricing";
    })]
  },
  testimonials: {
    label: "Testimonials",
    icon: "testimonials",
    blocks: [blocks.find(function (b) {
      return b.type === "testimonials";
    })]
  },
  textBanner: {
    label: "Text Banner",
    icon: "megaphone",
    blocks: [blocks.find(function (b) {
      return b.type === "text-banner";
    })]
  },
  footer: {
    label: "Modern Page Footer",
    icon: "footer",
    blocks: [{
      type: "divider",
      style: {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#1C252E",
        padding: "24px 0",
        width: "100%",
        background: "transparent"
      }
    }, {
      type: "text",
      content: {
        text: "© 2026 WillowSpace Technologies Inc. All rights reserved. Built with love by partner agencies globally."
      },
      style: {
        fontSize: "12px",
        textAlign: "center",
        color: "#6b7280",
        padding: "10px"
      }
    }, {
      type: "social",
      content: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
        instagram: "#"
      },
      style: {
        padding: "10px",
        textAlign: "center"
      }
    }]
  }
};
export var pageTemplates = {
  proposalStarter: {
    label: "Proposal Starter",
    icon: "document",
    description: "Cover, intro, pricing, and signature blocks.",
    blocks: [layoutBlocks.find(function (b) {
      return b.type === "cover";
    }), {
      type: "heading",
      content: {
        text: "Project Overview",
        tag: "h2"
      },
      style: {
        fontSize: "28px",
        color: "#1e293b",
        padding: "0"
      }
    }, {
      type: "text",
      content: {
        text: "Summarize the project goals, deliverables, and expected outcomes for your client."
      },
      style: {
        fontSize: "16px",
        color: "#475569",
        padding: "0"
      }
    }, layoutBlocks.find(function (b) {
      return b.type === "pricing";
    }), layoutBlocks.find(function (b) {
      return b.type === "signature";
    })]
  },
  contractStarter: {
    label: "Contract Starter",
    icon: "document",
    description: "Cover page, terms, milestones, and signatures.",
    blocks: [layoutBlocks.find(function (b) {
      return b.type === "cover";
    }), {
      type: "heading",
      content: {
        text: "Terms & Conditions",
        tag: "h2"
      },
      style: {
        fontSize: "28px",
        color: "#1e293b",
        padding: "0"
      }
    }, {
      type: "text",
      content: {
        text: "Outline the scope, payment terms, and responsibilities for both parties."
      },
      style: {
        fontSize: "16px",
        color: "#475569",
        padding: "0"
      }
    }, layoutBlocks.find(function (b) {
      return b.type === "timeline";
    }), layoutBlocks.find(function (b) {
      return b.type === "signature";
    })]
  }
};
export function renderTemplateThumbnail(key) {
  var frameStyle = {
    width: "100%",
    height: 112,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    boxSizing: "border-box",
    padding: 12,
    gap: 6,
    pointerEvents: "none"
  };
  var galleryImages = ["/imgs/New_Templates_Img/image-placeholder.png", "/imgs/New_Templates_Img/image-placeholder.png", "/imgs/New_Templates_Img/image-placeholder.png"];
  switch (key) {
    case "hero":
      return /*#__PURE__*/_jsxs("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          background: "#f8fafc",
          gap: 7
        }),
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 11,
            fontWeight: 700,
            color: "#0f172a",
            textAlign: "center",
            lineHeight: 1.25,
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Transform Your Business"
        }), /*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 8,
            fontWeight: 500,
            color: "#64748b",
            textAlign: "center",
            lineHeight: 1.35,
            maxWidth: "90%",
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Streamline documents, contracts & proposals in one place."
        }), /*#__PURE__*/_jsx("div", {
          style: {
            marginTop: 2,
            background: "#101828",
            color: "#fff",
            fontSize: 8,
            fontWeight: 600,
            padding: "5px 12px",
            borderRadius: 999,
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Get Started Now"
        })]
      });
    case "quote":
      return /*#__PURE__*/_jsxs("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          flexDirection: "row",
          alignItems: "stretch",
          gap: 10,
          padding: 14,
          background: "#f8fafc"
        }),
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: 3,
            borderRadius: 2,
            background: "#101828",
            alignSelf: "stretch",
            flexShrink: 0
          }
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 5,
            minWidth: 0
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 9,
              fontStyle: "italic",
              color: "#334155",
              lineHeight: 1.4,
              fontFamily: "Georgia, serif"
            },
            children: "\u201CDesign is not just what it looks like \u2014 design is how it works.\u201D"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 8,
              fontWeight: 600,
              color: "#0f172a",
              fontFamily: "DM Sans, sans-serif"
            },
            children: "\u2014 Steve Jobs"
          })]
        })]
      });
    case "gallery":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          flexDirection: "row",
          gap: 5,
          padding: 8
        }),
        children: galleryImages.map(function (src, i) {
          return /*#__PURE__*/_jsx("div", {
            style: {
              flex: 1,
              height: "100%",
              borderRadius: 5,
              backgroundImage: "url(".concat(src, ")"),
              backgroundSize: "cover",
              backgroundPosition: "center"
            }
          }, i);
        })
      });
    case "cta":
      return /*#__PURE__*/_jsxs("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
          borderColor: "#312e81",
          gap: 6
        }),
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 10,
            fontWeight: 700,
            color: "#ffffff",
            textAlign: "center",
            fontFamily: "DM Sans, sans-serif",
            lineHeight: 1.25
          },
          children: "Ready to boost efficiency?"
        }), /*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 8,
            fontWeight: 500,
            color: "#c7d2fe",
            textAlign: "center",
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Get started in less than 5 minutes."
        }), /*#__PURE__*/_jsx("div", {
          style: {
            marginTop: 2,
            background: "#ffffff",
            color: "#1e1b4b",
            fontSize: 8,
            fontWeight: 700,
            padding: "5px 11px",
            borderRadius: 999,
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Get Started Free"
        })]
      });
    case "threeColumn":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          flexDirection: "row",
          gap: 6,
          padding: 10,
          alignItems: "stretch",
          background: "#f8fafc"
        }),
        children: ["Strategy", "Design", "Launch"].map(function (title, i) {
          return /*#__PURE__*/_jsxs("div", {
            style: {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: 5,
              padding: 7,
              borderRadius: 6,
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              minWidth: 0
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                height: 22,
                borderRadius: 4,
                background: i === 0 ? "#e2e8f0" : i === 1 ? "#cbd5e1" : "#94a3b8"
              }
            }), /*#__PURE__*/_jsx("div", {
              style: {
                fontSize: 8,
                fontWeight: 700,
                color: "#0f172a",
                fontFamily: "DM Sans, sans-serif"
              },
              children: title
            }), /*#__PURE__*/_jsx("div", {
              style: {
                fontSize: 7,
                color: "#94a3b8",
                lineHeight: 1.3,
                fontFamily: "DM Sans, sans-serif"
              },
              children: "Short summary text"
            })]
          }, i);
        })
      });
    case "oneColumn":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          gap: 6,
          padding: 10,
          background: "#f8fafc"
        }),
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 5,
            padding: 10,
            borderRadius: 6,
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            width: "100%"
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              height: 28,
              borderRadius: 4,
              background: "#e2e8f0"
            }
          }), /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 8,
              fontWeight: 700,
              color: "#0f172a",
              fontFamily: "DM Sans, sans-serif"
            },
            children: "Single column"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 7,
              color: "#94a3b8",
              lineHeight: 1.3,
              fontFamily: "DM Sans, sans-serif"
            },
            children: "Full-width content area"
          })]
        })
      });
    case "logos":
      return /*#__PURE__*/_jsxs("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          gap: 8,
          background: "#f8fafc"
        }),
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 8,
            fontWeight: 600,
            color: "#64748b",
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Trusted by leading brands"
        }), /*#__PURE__*/_jsx("div", {
          style: {
            display: "flex",
            gap: 6,
            width: "100%",
            padding: "0 4px"
          },
          children: ["Acme", "Nova", "Pulse", "Orbit"].map(function (name) {
            return /*#__PURE__*/_jsx("div", {
              style: {
                flex: 1,
                height: 28,
                borderRadius: 5,
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 7,
                fontWeight: 700,
                color: "#94a3b8",
                fontFamily: "DM Sans, sans-serif"
              },
              children: name
            }, name);
          })
        })]
      });
    case "logoText":
      return /*#__PURE__*/_jsxs("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          flexDirection: "row",
          gap: 12,
          padding: "16px 14px",
          alignItems: "center",
          background: "#ffffff"
        }),
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: 48,
            height: 48,
            borderRadius: 10,
            background: "#f1f5f9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 9,
            fontWeight: 700,
            color: "#0f172a",
            fontFamily: "DM Sans, sans-serif",
            flexShrink: 0
          },
          children: "Logo"
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 4,
            minWidth: 0
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 11,
              fontWeight: 700,
              color: "#0f172a",
              fontFamily: "DM Sans, sans-serif",
              lineHeight: 1.25
            },
            children: "Your Brand Name"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 8,
              fontWeight: 400,
              color: "#64748b",
              lineHeight: 1.4,
              fontFamily: "DM Sans, sans-serif"
            },
            children: "Short tagline or description about your brand."
          })]
        })]
      });
    case "accordion":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          gap: 5,
          padding: 10,
          alignItems: "stretch",
          background: "#f8fafc"
        }),
        children: [{
          title: "What is included?",
          open: true
        }, {
          title: "How does billing work?",
          open: false
        }, {
          title: "Can I cancel anytime?",
          open: false
        }].map(function (item, i) {
          return /*#__PURE__*/_jsxs("div", {
            style: {
              borderRadius: 5,
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              overflow: "hidden"
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "5px 8px"
              },
              children: [/*#__PURE__*/_jsx("div", {
                style: {
                  fontSize: 8,
                  fontWeight: 600,
                  color: "#0f172a",
                  fontFamily: "DM Sans, sans-serif"
                },
                children: item.title
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  fontSize: 9,
                  color: "#94a3b8",
                  lineHeight: 1
                },
                children: item.open ? "−" : "+"
              })]
            }), item.open && /*#__PURE__*/_jsx("div", {
              style: {
                padding: "0 8px 6px",
                fontSize: 7,
                color: "#64748b",
                lineHeight: 1.35,
                fontFamily: "DM Sans, sans-serif"
              },
              children: "Full access to all features and premium support."
            })]
          }, i);
        })
      });
    case "pricing":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          flexDirection: "row",
          gap: 5,
          padding: 8,
          alignItems: "stretch",
          background: "#f8fafc"
        }),
        children: [{
          name: "Starter",
          price: "$19",
          hot: false
        }, {
          name: "Pro",
          price: "$49",
          hot: true
        }, {
          name: "Enterprise",
          price: "$99",
          hot: false
        }].map(function (plan) {
          return /*#__PURE__*/_jsxs("div", {
            style: {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
              padding: "8px 4px",
              borderRadius: 6,
              background: plan.hot ? "#101828" : "#ffffff",
              border: plan.hot ? "1px solid #101828" : "1px solid #e2e8f0",
              minWidth: 0
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                fontSize: 7,
                fontWeight: 600,
                color: plan.hot ? "#94a3b8" : "#64748b",
                fontFamily: "DM Sans, sans-serif"
              },
              children: plan.name
            }), /*#__PURE__*/_jsx("div", {
              style: {
                fontSize: 12,
                fontWeight: 700,
                color: plan.hot ? "#ffffff" : "#0f172a",
                fontFamily: "DM Sans, sans-serif"
              },
              children: plan.price
            }), /*#__PURE__*/_jsx("div", {
              style: {
                marginTop: 2,
                fontSize: 6,
                fontWeight: 600,
                padding: "3px 6px",
                borderRadius: 999,
                background: plan.hot ? "#ffffff" : "#e2e8f0",
                color: plan.hot ? "#101828" : "#475569",
                fontFamily: "DM Sans, sans-serif"
              },
              children: "Choose"
            })]
          }, plan.name);
        })
      });
    case "testimonials":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          flexDirection: "row",
          gap: 6,
          padding: 10,
          alignItems: "stretch",
          background: "#f8fafc"
        }),
        children: [{
          quote: "Doubled our close rate!",
          name: "Sarah J."
        }, {
          quote: "Best investment this year.",
          name: "Mike C."
        }].map(function (t, i) {
          return /*#__PURE__*/_jsxs("div", {
            style: {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: 6,
              padding: 8,
              borderRadius: 6,
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              minWidth: 0
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                fontSize: 8,
                color: "#475569",
                lineHeight: 1.35,
                fontFamily: "DM Sans, sans-serif"
              },
              children: ["\u201C", t.quote, "\u201D"]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: 5
              },
              children: [/*#__PURE__*/_jsx("div", {
                style: {
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  background: i === 0 ? "#94a3b8" : "#cbd5e1",
                  flexShrink: 0
                }
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  fontSize: 7,
                  fontWeight: 600,
                  color: "#0f172a",
                  fontFamily: "DM Sans, sans-serif"
                },
                children: t.name
              })]
            })]
          }, i);
        })
      });
    case "textBanner":
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          background: "#ffffff",
          borderColor: "#e2e8f0",
          padding: 10
        }),
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
            padding: "16px 12px",
            borderRadius: 10,
            background: "#f1f5f9",
            boxSizing: "border-box"
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 11,
              fontWeight: 700,
              color: "#0f172a",
              textAlign: "center",
              fontFamily: "DM Sans, sans-serif",
              lineHeight: 1.25
            },
            children: "Important update"
          }), /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 8,
              fontWeight: 400,
              color: "#64748b",
              textAlign: "center",
              fontFamily: "DM Sans, sans-serif",
              lineHeight: 1.4
            },
            children: "A notification message for your readers."
          })]
        })
      });
    case "footer":
      return /*#__PURE__*/_jsxs("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          gap: 8,
          padding: 14,
          background: "#f8fafc"
        }),
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: "100%",
            height: 1,
            background: "#e2e8f0"
          }
        }), /*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 7,
            color: "#94a3b8",
            textAlign: "center",
            fontFamily: "DM Sans, sans-serif"
          },
          children: "\xA9 2026 WillowSpace \xB7 All rights reserved"
        }), /*#__PURE__*/_jsx("div", {
          style: {
            display: "flex",
            gap: 6
          },
          children: ["f", "x", "in", "ig"].map(function (s) {
            return /*#__PURE__*/_jsx("div", {
              style: {
                width: 16,
                height: 16,
                borderRadius: "50%",
                background: "#e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 7,
                fontWeight: 700,
                color: "#64748b",
                fontFamily: "DM Sans, sans-serif"
              },
              children: s
            }, s);
          })
        })]
      });
    default:
      return /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, frameStyle), {}, {
          background: "#f8fafc"
        }),
        children: /*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 10,
            fontWeight: 600,
            color: "#94a3b8",
            fontFamily: "DM Sans, sans-serif"
          },
          children: "Section preview"
        })
      });
  }
}